import { Municipality } from 'interface'
import { apiClient } from './config'

export const fetchMunicipalities = async (params?: {
  'state_abbr': string
}) : Promise<{
  _metadata: {
    success: boolean
  },
  result: {
    municipalities: Municipality[]
  }
}> => {
  const filteredParams = Object.fromEntries(
    Object.entries(params || {})
      .filter(([_, value]) => value !== undefined)  // filter out undefined values
      .map(([key, value]) => [key, value.toString()]) // convert values to strings
  )

  const queryString = new URLSearchParams(filteredParams).toString()
  const response = await apiClient(`municipalities?${queryString}`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return response
}
